import { Component } from '@angular/core';
import { SidebarNavItem } from '../../component/sidebar-layout/sidebar-layout.component';

@Component({
  selector: 'host',
  templateUrl: './host.page.html',
})
export class HostPage {
  readonly menu: SidebarNavItem[] = [
    { label: '상품 관리', icon: '/assets/admin/icons8-product-documents-48.png', link: '/host/products' },
    // /host/schedule(티켓 관리)와 /host/schedule/daily(일정 요약)가 prefix 매칭으로 동시에 active 되지 않도록 정확 매칭.
    { label: '일정 관리', icon: '/assets/admin/icons8-calendar-48.png', link: '/host/schedule', exact: true },
    { label: '예약 관리', icon: '/assets/admin/icons8-calendar-check-48.png', link: '/host/reservation' },
    { label: '일정 요약', icon: '/assets/tossface/u1F4C6.svg', link: '/host/schedule/daily', exact: true },
    { label: '메시지 관리', icon: '/assets/admin/icons8-chat-48.png', link: '/host/inquiry' },
    { label: '후기 관리', icon: '/assets/admin/icons8-team-48.png', link: '/host/review' },
    { label: '정산 관리', icon: '/assets/admin/icons8-coins-48.png', link: '/host/settlement' },
    { label: '통계', icon: '/assets/admin/icons8-graph-48.png', link: '/host/stat' },
    { label: '호스트 정보', icon: '/assets/admin/icons8-name-tag-48.png', link: '/host/info' },
    { label: '공지사항', icon: '/assets/admin/icons8-info-48.png', link: '/host/blog' },
    { label: '설정', icon: '/assets/admin/icons8-settings-48.png', link: '/host/settings' },
    { label: '도움말', icon: '/assets/admin/icons8-help-48.png', externalUrl: 'https://nnbhost.super.site' },
  ];
}
